import { View } from "./View";

export const ActivityIndicator = () => {
  return <View />;
};
